import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "api-code",
  "use": "api-code-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"api-code\"><path fill-rule=\"evenodd\" d=\"M4 20h16V4H4v16ZM4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm2.91 5.41L11.5 12l-4.59 4.6-1.41-1.42L8.68 12 5.5 8.82l1.41-1.41ZM13 13h5v2h-5v-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol